import { render, staticRenderFns } from "./ArmsRegArchiveCompletionInfo.vue?vue&type=template&id=50ec1de2&scoped=true&"
import script from "./ArmsRegArchiveCompletionInfo.vue?vue&type=script&lang=js&"
export * from "./ArmsRegArchiveCompletionInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ec1de2",
  null
  
)

export default component.exports